var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var allow_priced_services = settings.allow_priced_services ? settings.allow_priced_services : 0;
  var OAB_price_override = settings.OAB_override_price_format ? settings.OAB_override_price_format : 0;
  var currencySymbol = settings.OAB_price_currency ? settings.OAB_price_currency : '$';

  /* Concrete View */
  apptBook.ServicesSelectSection = function (container) {
    apptBook.ServicesSelectSection.superclass.constructor.call(this);
    this.id = 'services';
    this.container = container;
    this.servContainer = container.find('.services-container');
    this.servMakeupContainer = container.find('.services-makeup');
    this.servMakeupContent = this.servMakeupContainer.find('.services-makeup-content');
    this.servSkincareContainer = container.find('.services-skincare');
    this.servSkincareContent = this.servSkincareContainer.find('.services-skincare-content');
    this.servicesMakeup = this.servMakeupContainer.find('.service').css('display', 'none').detach();
    this.servicesSkincare = this.servSkincareContainer.find('.service').css('display', 'none').detach();
    this.services = this.servContainer.find('.service').css('display', 'none').detach();
    this.isMakeup = 0;
    this.isSkincare = 0;
    this.bookBar = container.find('.book-now-bar');
    this.totTime = this.bookBar.find('.minutes');
    this.bookBtn = this.bookBar.find('.button');
    this.initialised = false;
    this.minLabel = container.attr('data-minutes-label');
    this.maxSelections = parseInt(container.attr('data-max-select'));
    this.msOverlay = container.find('.appt-book-services-overlay').remove();
    // this.msOverlayClose = this.msOverlay.find('.overlay-close');
    this.jqBod = $('body');
    this.backTo = this.container.find('.back-to-link');
    this.boundRun = this.runBuild.bind(this);

    if (this.maxSelections === null || typeof this.maxSelections === 'undefined' || isNaN(this.maxSelections)) {
      this.maxSelections = 2;
    }
  };

  ctrlopt.extend(apptBook.ServicesSelectSection, apptBook.AbstractSection);

  apptBook.ServicesSelectSection.prototype.buildServices = function () {
    if (!this.buildParams || !this.buildParams.counterId) {
      return;
    }

    var serviceSelections, cServices,
      serviceMap = {},
      myMakeupServices = $(),
      mySkincareServices = $(),
      me = this;

    if (this.servMakeupContainer && this.servMakeupContainer[0]) {
      servMakeupContainer = this.servMakeupContainer.clone(),
      servMakeupContent = servMakeupContainer.find('.services-makeup-content');
    }
    if (this.servSkincareContainer && this.servSkincareContainer[0]) {
      servSkincareContainer = this.servSkincareContainer.clone(),
      servSkincareContent = servSkincareContainer.find('.services-skincare-content');
    }
    this.myServices = $();

    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var s = this.servicesData[i];

      serviceMap[s.id] = s;
    }

    this.counterId = this.buildParams.counterId;
    this.maxSelections = this.buildParams.maxSelections > 0 ? this.buildParams.maxSelections : this.maxSelections;

    this.backTo.off('click').on('click', function(e) {
      var updateData = {
        sectionId: 'previous',
        params: {
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(updateData);
    });

    cServices = this.model.getCounterServices(this.counterId);
    if (cServices) {
      this.services.each(function () {
        var sdata, serv, price,
          $this = $(this),
          onlineContentId = $this.attr('data-content-id');

        if (checkService(onlineContentId)) {
          sdata = me.model.getService(onlineContentId);
          if (sdata) {
            serv = $this.clone();
            serv.attr('data-total-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + ' ' + me.minLabel);
            serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);
            if (parseInt(sdata.price) && allow_priced_services) {
              if (OAB_price_override) {
                price = parseInt(sdata.price) + '\xA0' + currencySymbol;
              } else {
                price = currencySymbol + parseInt(sdata.price);
              }
              serv.attr('data-price', sdata.price).find('.selection-price').text(price);
              serv.find('.selection-selector').addClass('priced');
            }
            serv.attr('data-service-id', sdata.id);
            serv.find('.selection-selector').on('click', function(e) {
              var sText, stat,
                $this = $(this),
                icon = $this.find('.icon').remove(),
                par = $this.parents('.service'),
                dur = par.attr('data-total-duration');

              if ($this.hasClass('selected')) {
                sText = $this.attr('data-select-text');
                stat = 'not-selected';
                $this.removeClass('selected');
                par.removeClass('selected');
              } else {
                sText = $this.attr('data-selected-text');
                stat = 'selected';
                $this.removeClass('not-selected');
                par.removeClass('not-selected');
              }

              $this.addClass(stat).html(sText).prepend(icon);
              par.attr('data-status', stat).addClass(stat);
              updateBar(par);
            });
          }

          me.myServices = me.myServices.add(serv);
        }
      });
      if (this.servMakeupContainer && this.servMakeupContainer[0]) {
        this.servicesMakeup.each(function () {
          var sdata, serv,
            $this = $(this),
            onlineContentId = $this.attr('data-content-id');

          if (checkService(onlineContentId)) {
            sdata = me.model.getService(onlineContentId);
            me.isMakeup = 1;
            serv = servicesData($this, sdata);
            myMakeupServices = myMakeupServices.add(serv);
          }
        });
      }

      if (this.servSkincareContainer && this.servSkincareContainer[0]) {
        this.servicesSkincare.each(function () {
          var sdata, serv,
            $this = $(this),
            onlineContentId = $this.attr('data-content-id');

          if (checkService(onlineContentId)) {
            sdata = me.model.getService(onlineContentId);
            me.isSkincare = 1;
            serv = servicesData($this, sdata);
            mySkincareServices = mySkincareServices.add(serv);
          }
        });
      }
      function servicesData($this, sdata) {
        if (sdata) {
          var serv = $this.clone(),
            price;

          serv.attr('data-total-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + ' ' + me.minLabel);
          if (parseInt(sdata.price) && allow_priced_services) {
            if (OAB_price_override) {
              price = parseInt(sdata.price) + '\xA0' + currencySymbol;
            } else {
              price = currencySymbol + parseInt(sdata.price);
            }
            serv.attr('data-price', sdata.price).find('.selection-price').text(price);
            serv.find('.selection-selector').addClass('priced');
          }
          serv.attr('data-service-id', sdata.id);
          serv.find('.selection-selector').on('click', function(e) {
            var sText, stat,
              $this = $(this),
              icon = $this.find('.icon').remove(),
              par = $this.parents('.service'),
              dur = par.attr('data-total-duration'),
              pri = par.attr('data-price');

            if ($this.hasClass('selected')) {
              sText = $this.attr('data-select-text');
              stat = 'not-selected';
              $this.removeClass('selected');
              par.removeClass('selected');
            } else {
              sText = $this.attr('data-selected-text');
              stat = 'selected';
              $this.removeClass('not-selected');
              par.removeClass('not-selected');
            }

            $this.addClass(stat).html(sText).prepend(icon);
            par.attr('data-status', stat).addClass(stat);
            updateBar(par);
          });

          return serv;
        }
      }
      me.servMakeupContainer.detach();
      me.servSkincareContainer.detach();
      this.servContainer.append(this.myServices);
      if (this.servMakeupContainer && this.servMakeupContainer[0] && this.isMakeup) {
        servMakeupContent.append(myMakeupServices);
        this.servContainer.after(servMakeupContainer);
        this.servMakeupContainer = this.container.find('.services-makeup');
        this.servMakeupContent = this.servMakeupContainer.find('.services-makeup-content');
        myMakeupServices.css('display', 'block');
        this.isMakeup = 0;
      }
      if (this.servSkincareContainer && this.servSkincareContainer[0] && this.isSkincare) {
        servSkincareContent.append(mySkincareServices);
        this.servContainer.after(servSkincareContainer);
        this.servSkincareContainer = this.container.find('.services-skincare');
        this.servSkincareContent = this.servSkincareContainer.find('.services-skincare-content');
        mySkincareServices.css('display', 'block');
        this.isSkincare = 0;
      }
      this.myServices.css('display', 'block');

      updateBar();
      this.bookBtn.off('click');
      this.bookBtn.on('click', function(e) {
        var updateData,
          anStr = serviceSelections.length + 'Apt',
          $this = $(this);

        if ($this.hasClass('disabled')) {
          return;
        }

        var serviceNames = serviceSelections.map(function (element) {
          return element.serviceName.trim();
        }).join('|');

        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_Service',
          event_category: 'appointment booking',
          event_action: 'services selected',
          event_label: serviceNames
        });
        updateData = {
          sectionId: 'next',
          params: {
            counterId: me.counterId,
            services: serviceSelections,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      });

      this.myServices.each(function () {
        var serv = $(this),
          sHead = serv.find('.service-head'),
          closeH = sHead.height(),
          openH = serv.height();

        serv.attr('data-close', closeH);
        serv.attr('data-open', openH);
        serv.css('height', closeH + 'px');

        sHead.on('click', function(e) {
          var $this = $(this),
            myServ = $this.parents('.service');

          if (myServ.hasClass('expanded')) {
            closeServ(myServ, $this);
          } else {
            openServ(myServ, $this);
          }

          e.preventDefault();
        });
      });
      if (this.servSkincareContainer && this.servSkincareContainer[0]) {
        this.servSkincareContainer.each(function () {
          var servSkincare = $(this),
            sHead = servSkincare.find('.service-head'),
            serv = servSkincare.find('.service'),
            closeH = sHead.height(),
            openH = serv.height();

          serv.attr('data-close', closeH);
          serv.attr('data-open', openH);
          serv.css('height', closeH + 'px');

          sHead.on('click', function(e) {
            var $this = $(this),
              myServ = $this.parents('.service');

            if (myServ.hasClass('expanded')) {
              closeServ(myServ, $this);
            } else {
              openServ(myServ, $this);
            }

            e.preventDefault();
          });
        });
      }
      if (this.servMakeupContainer && this.servMakeupContainer[0]) {
        this.servMakeupContainer.each(function () {
          var servMakeup = $(this),
            sHead = servMakeup.find('.service-head'),
            serv = servMakeup.find('.service'),
            closeH = sHead.height(),
            openH = serv.height();

          serv.attr('data-close', closeH);
          serv.attr('data-open', openH);
          serv.css('height', closeH + 'px');

          sHead.on('click', function(e) {
            var $this = $(this),
              myServ = $this.parents('.service');

            if (myServ.hasClass('expanded')) {
              closeServ(myServ, $this);
            } else {
              openServ(myServ, $this);
            }

            e.preventDefault();
          });
        });
      }
    }

    function checkService(id) {
      if (cServices) {
        for (var i = 0, len = cServices.length; i < len; i += 1) {
          var sId = cServices[i];

          if (id === serviceMap[sId].online_content_id) {
            return true;
          }
        }
      }

      return false;
    }

    function updateBar(lastSelection) {
      var sel, selBtn, sText, icon, formattedTotalTime, formattedTotalPrice,
        selected = me.servContainer.children('.selected'),
        totalTime = 0,
        totalPrice = 0;

      if (me.servMakeupContainer && me.servMakeupContainer[0]) {
        var selectedMakeup = me.servMakeupContent.children('.selected');

        $.merge(selected, selectedMakeup);
      }
      if (me.servSkincareContainer && me.servSkincareContainer[0]) {
        var selectedSkincare = me.servSkincareContent.children('.selected');

        $.merge(selected, selectedSkincare);
      }

      serviceSelections = [];

      if (selected.length > me.maxSelections) {
        me.jqBod.prepend(me.msOverlay);
        me.msOverlay.css('display', 'block').on('click', function(e) {
          e.preventDefault();
          me.msOverlay.remove();
        });

        if (lastSelection && selected.length === (me.maxSelections + 1)) {
          sel = lastSelection.removeClass('selected').attr('data-status', 'not-selected');
          selBtn = sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
          sText = selBtn.attr('data-select-text');
          selBtn.text(sText);
        } else {
          for (var i = me.maxSelections, len = selected.length; i < len; i += 1) {
            sel = selected.eq(i).removeClass('selected').attr('data-status', 'not-selected');
            selBtn = sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
            icon = selBtn.find('.icon').remove();
            sText = selBtn.attr('data-select-text');
            selBtn.html(sText).prepend(icon);
          }
        }

        updateBar();

        return;
      }

      selected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration')),
          timeWithPadding = parseInt($this.attr('data-total-duration-with-padding')),
          price = parseInt($this.attr('data-price')),
          serviceId = parseInt($this.attr('data-service-id')),
          serviceName = $this.find('.service-title').text();

        totalTime += time;
        totalPrice += price;
        serviceSelections.push({
          serviceId: serviceId,
          serviceDuration: time,
          serviceDurationWithPadding: timeWithPadding,
          servicePrice: price,
          serviceName: serviceName
        });
      });

      if (totalTime > 0) {
        me.totTime.removeClass('disabled');
        me.bookBtn.removeClass('disabled');
      } else {
        me.totTime.addClass('disabled');
        me.bookBtn.addClass('disabled');
      }
      formattedTotalTime = totalTime + ' ' + me.minLabel;
      if (totalPrice && allow_priced_services) {
        if (OAB_price_override) {
          formattedTotalPrice = totalPrice + '\xA0' + currencySymbol;
        } else {
          formattedTotalPrice = currencySymbol + totalPrice;
        }
        me.totTime.text(formattedTotalTime + ' / ' + formattedTotalPrice);
        me.totTime.addClass('small');
      } else {
        me.totTime.text(formattedTotalTime);
        me.totTime.removeClass('small');
      }
    }

    function openServ(serv, servHead) {
      var h;

      if (serv.hasClass('selected') || serv.hasClass('expanded') || servHead.hasClass('disabled')) {
        return;
      }
      servHead.addClass('disabled');
      h = serv.attr('data-open');

      me.myServices.filter('.expanded').each(function () {
        var $t = $(this),
          sH = $t.find('.service-head');

        closeServ($t, sH);
      });

      serv.addClass('expanded');
      serv.animate({ height: h + 'px' }, 700, function () {
        serv.css('height', 'auto');
        servHead.removeClass('disabled');
      });
    }

    function closeServ(serv, servHead) {
      var h;

      if (serv.hasClass('selected') || !serv.hasClass('expanded') || servHead.hasClass('disabled')) {
        return;
      }
      servHead.addClass('disabled');
      h = serv.attr('data-close');
      serv.animate({ height: h + 'px' }, 700, function () {
        servHead.removeClass('disabled');
        serv.removeClass('expanded');
      });
    }
  };

  apptBook.ServicesSelectSection.prototype.runBuild = function () {
    this.buildServices();
  };

  apptBook.ServicesSelectSection.prototype.onUpdate = function (data) {
    if (data.sectionId === this.id) {
      this.buildParams = data.params;
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      /* this.countersData = this.model.getCounters();*/
      this.servicesData = this.model.getServices();
      if (this.myServices && this.myServices.length) {
        this.myServices.remove();
      }
      this.myServices = null;
      if (this.servMakeupContainer && this.servMakeupContainer[0]) {
        this.servMakeupContent.empty();
      }
      this.servMakeupContent = null;
      if (this.servSkincareContainer && this.servSkincareContainer[0]) {
        this.servSkincareContent.empty();
      }
      this.servSkincareContent = null;
      apptBook.sectionManager.on('transition_in_start', this.boundRun);
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundRun);
    }
  };

  Drupal.behaviors.apptBookServices = {
    attach: function (context) {
      var view = new apptBook.ServicesSelectSection($('#services'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
